"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
var _MenuList = _interopRequireDefault(require("./MenuList"));
var _popover = _interopRequireWildcard(require("../popover"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Menu = _ref => {
  let {
    className,
    anchorEl,
    position,
    children,
    onClose
  } = _ref;
  const containerRef = _react.default.useRef(null);
  return /*#__PURE__*/_react.default.createElement(_popover.default, {
    anchorEl: anchorEl,
    position: position,
    overflow: false,
    onClickOutside: onClose,
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    className: className,
    containerRef: containerRef
  }, children));
};
process.env.NODE_ENV !== "production" ? Menu.propTypes = {
  className: _propTypes.default.string,
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(HTMLElement), _propTypes.default.shape({
    current: _propTypes.default.instanceOf(HTMLElement).isRequired
  })]),
  position: _propTypes.default.oneOf(Object.values(_popover.PopoverPosition)),
  children: _propTypes.default.node,
  onClose: _propTypes.default.func
} : void 0;
Menu.defaultProps = {
  className: undefined,
  anchorEl: undefined,
  position: undefined,
  children: undefined,
  onClose: undefined
};
var _default = exports.default = Object.assign(Menu, {
  Item: _MenuItem.default
});